module.exports = __webpack_public_path__ + "img/edit.87b0a959.svg";